export default __webpack_public_path__ + "static/heading_brands-18a2199e625b751197e30a9d7e09c632.svg";